<template>
  <div class="company-seal tb">
    <div class="search-hd">
      <el-button type="primary" @click="onAdd">{{ $t('crm_companySeal.tian_jia_yin_zhang') }}</el-button>
    </div>
    <div class="table-bd">
      <custom-table :data="list" :column="tableColumn" :index="true" @filter="filterChange" @sort="sortChange" :slots="['seal_img', 'is_default']">
        <template v-slot:seal_img="scope">
          <img :src="scope.row.seal_img" />
        </template>
        <template v-slot:is_default="scope">
          <span>
            {{ scope.row.is_default ? $t('crm_companySeal.mo_ren_yin_zhang') : $t('crm_companySeal.szwmryz') }}
          </span>
        </template>
        <el-table-column :label="$t('Common.com_handle')">
          <template slot-scope="scope">
            <span></span>
            <el-button type="text" size="mini" @click="onEdit">{{ $t('Common.com_edit') }}</el-button>
            <el-button type="text" size="mini" v-if="!scope.row.is_default">{{ $t('Common.com_delete') }}</el-button>
          </template>
        </el-table-column>
      </custom-table>
    </div>
    <company-seal-item-dialog v-if="showCompanySealItemDialog" @close="showCompanySealItemDialog = false" :type="type"></company-seal-item-dialog>
  </div>
</template>

<script>
import companySealItemDialog from './children/company_seal_item_dialog.vue';

export default {
  name: 'companySeal',
  components: {
    companySealItemDialog,
  },
  data() {
    return {
      list: [{}],
      formSeach: {
        search: '',
        orderType: '',
        orderBy: '',
        pageSize: 50,
        pageNum: 1,
      },
      tableCode: 'company_seal_list',
      showCompanySealItemDialog: false,
      type: 'edit',
    };
  },
  methods: {
    onEdit() {
      this.type = 'edit';
      this.showCompanySealItemDialog = true;
    },
    onAdd() {
      this.type = 'add';
      this.showCompanySealItemDialog = true;
    },
  },
  mounted() {
    this.getTableColumn();

  },
};
</script>

<style lang="scss" scoped></style>
